import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { DesktopRightSidebar } from 'shared/components/BannerAll';
import Breadcrumbs from 'desktop/components/Breadcrumbs/Breadcrumbs';
import MakesSidebar from 'desktop/components/MakesSidebar/MakesSidebar';
import DealerImages from 'desktop/routes/dealer/components/DealerImages/DealerImages';
import TabButtons from 'desktop/components/TabButtons/TabButtons';
import { DEALER_TABS } from 'shared/constants/navigation';
import About from 'shared/components/About';
import FirmInfo from './components/FirmInfo/FirmInfo';
import s from './Firm.css';

class Firm extends React.Component {
  static propTypes = {
    firmInfo: PropTypes.shape().isRequired,
    tab: PropTypes.string.isRequired,
    //
    intl: intlShape.isRequired,
  };

  render() {
    const { firmInfo, tab, intl } = this.props;
    const { photos, description, worktime, title, slug, ...info } = firmInfo;

    const breadcrumbs = [
      {
        link: '/service',
        title: intl.formatMessage({ id: 'Сервисы' }),
      },
      {
        link: '/service/prygon-avto',
        title: intl.formatMessage({ id: 'Пригон авто' }),
      },
    ];

    const tabButtons = [
      {
        title: intl.formatMessage({ id: 'О компании' }),
        tab: DEALER_TABS.ABOUT,
        slug: DEALER_TABS.ABOUT,
      },
    ];

    const pathname = `/service/${slug}`;

    return (
      <div className={s.page}>
        <div className={s.container}>
          <div className={s.flexRow}>
            <div className={cx(s.flexCell, s.mainCell)}>
              <Breadcrumbs links={breadcrumbs} />
              <FirmInfo type={'firm'} schedule={worktime} title={title} {...info}>
                {photos.length > 0 && <DealerImages photos={photos} />}
              </FirmInfo>
              <TabButtons activeTab={tab} buttons={tabButtons} pathname={pathname} />
              {tab === DEALER_TABS.ABOUT && <About content={description} />}
            </div>
            <DesktopRightSidebar>
              <MakesSidebar />
            </DesktopRightSidebar>
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(s)(injectIntl(Firm));



// WEBPACK FOOTER //
// ./src/desktop/routes/service/car-drive/firm/Firm.js